// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    padding: 16px;
    border: 1px solid #0f0f0f;
    margin-top: 70px;
    width: 400px;
}

h3 {
    text-align: center;
    color: #5e5e5e;
    font-family: "Calibri Light", sans-serif;
}

h4 {
    color: #5e5e5e;
    font-family: "Calibri Light", sans-serif;
    font-weight: bold;
}

h1 {
    text-align: center;
    color: #337ab7;
    font-family: "Calibri Light", sans-serif;
    font-weight: bold;

}

.register-form {
   padding-left: 16px;
   padding-right: 16px;
}

input[type=text], input[type=password], input[type=tel], input[type=email] {
    width: 100%;
    padding: 12px 20px;
    margin: 2px 0;
    display: inline-block;
    border: 1px solid #ccc;
    box-sizing: border-box;
}

.default {
    background-color: #337ab7;
    color: white;
    margin: 8px 0;
}

.wrapper {
    text-align: center;
    /*text-align: left;*/
}

#logo {
    width: 30px;
    height: 30px;
    margin-top: -5px;
}

a {
   color: #8c8c8c
}

a:hover {
    color: #f4f5f7;
    text-decoration: blink;
}

@media screen and (max-width: 400px) {
    .container{
        display: block;
        float: none;
        margin-top: 70px;
        width: 360px;
    }

}

.error {
   font-size: 12px;
   color: #d32f2f;
   text-align: left;
}

img {
   width: 80px;
   height: auto;
   margin: 5px;
}

mat-icon {
   width: 32px;
   height: 32px;
   line-height: 32px;
   padding: 4px;
   text-align: center;
   position: absolute;
   right: 0;
   margin-top: 5px;
}

input {
   height: 32px;
   padding-right: 36px;
   width: 100%;
}

.pwd-hint {
   margin-top: 5px;
   margin-bottom: 1em;
}
`, "",{"version":3,"sources":["webpack://./src/app/account/reset-password/reset-password.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,wCAAwC;IACxC,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,wCAAwC;IACxC,iBAAiB;;AAErB;;AAEA;GACG,kBAAkB;GAClB,mBAAmB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;GACG;AACH;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,YAAY;IAChB;;AAEJ;;AAEA;GACG,eAAe;GACf,cAAc;GACd,gBAAgB;AACnB;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,WAAW;AACd;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,iBAAiB;GACjB,YAAY;GACZ,kBAAkB;GAClB,kBAAkB;GAClB,QAAQ;GACR,eAAe;AAClB;;AAEA;GACG,YAAY;GACZ,mBAAmB;GACnB,WAAW;AACd;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB","sourcesContent":[".container {\n    padding: 16px;\n    border: 1px solid #0f0f0f;\n    margin-top: 70px;\n    width: 400px;\n}\n\nh3 {\n    text-align: center;\n    color: #5e5e5e;\n    font-family: \"Calibri Light\", sans-serif;\n}\n\nh4 {\n    color: #5e5e5e;\n    font-family: \"Calibri Light\", sans-serif;\n    font-weight: bold;\n}\n\nh1 {\n    text-align: center;\n    color: #337ab7;\n    font-family: \"Calibri Light\", sans-serif;\n    font-weight: bold;\n\n}\n\n.register-form {\n   padding-left: 16px;\n   padding-right: 16px;\n}\n\ninput[type=text], input[type=password], input[type=tel], input[type=email] {\n    width: 100%;\n    padding: 12px 20px;\n    margin: 2px 0;\n    display: inline-block;\n    border: 1px solid #ccc;\n    box-sizing: border-box;\n}\n\n.default {\n    background-color: #337ab7;\n    color: white;\n    margin: 8px 0;\n}\n\n.wrapper {\n    text-align: center;\n    /*text-align: left;*/\n}\n\n#logo {\n    width: 30px;\n    height: 30px;\n    margin-top: -5px;\n}\n\na {\n   color: #8c8c8c\n}\n\na:hover {\n    color: #f4f5f7;\n    text-decoration: blink;\n}\n\n@media screen and (max-width: 400px) {\n    .container{\n        display: block;\n        float: none;\n        margin-top: 70px;\n        width: 360px;\n    }\n\n}\n\n.error {\n   font-size: 12px;\n   color: #d32f2f;\n   text-align: left;\n}\n\nimg {\n   width: 80px;\n   height: auto;\n   margin: 5px;\n}\n\nmat-icon {\n   width: 32px;\n   height: 32px;\n   line-height: 32px;\n   padding: 4px;\n   text-align: center;\n   position: absolute;\n   right: 0;\n   margin-top: 5px;\n}\n\ninput {\n   height: 32px;\n   padding-right: 36px;\n   width: 100%;\n}\n\n.pwd-hint {\n   margin-top: 5px;\n   margin-bottom: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
